module.exports = __webpack_public_path__ + "static/media/design.393f3064.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/StartupCards/assets/design.png
// module id = 529
// module chunks = 0